import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { RfpProfessionalNegotiateSkeleton } from '@/components/modules/pages/rfp/professional/Content/RfpProfessionalNegotiateContent/RfpProfessionalNegotiateSkeleton';
import { RfpProfessionalOneSkeletonLayout } from '@/components/modules/pages/rfp/professional/Layout/RfpProfessionalOneSkeletonLayout';
import { useRfpOneProfessional } from '@/hooks/pages/rfp/professional/useRfpOneProfessional';
import { RfpProfessionalFilePage } from '@/pages/rfp/professional/RfpProfessionalFile/RfpProfessionalFilePage';
import { useRfpProfessionalFileFetchMessage } from '@/pages/rfp/professional/RfpProfessionalFile/useRfpProfessionalFileFetchMessage';
import { RFP_PROFESSIONAL_DATA_TYPE_UNAPPROVED } from '@/utils/constants/rfp/professional/dataType';
import { myPagePath, professionalRfpOnePath } from '@/utils/router/links';
export const RfpProfessionalFile = (props) => {
    var _a;
    const { match, profile } = props;
    const rfpId = ((_a = match === null || match === void 0 ? void 0 : match.params) === null || _a === void 0 ? void 0 : _a.id) || '';
    /** 案件詳細ページへのパス */
    const rfpOnePath = professionalRfpOnePath(rfpId);
    // ファイル共有データを取得処理
    const { changeFileShareData, fetchFileShare, fileShareData } = useRfpProfessionalFileFetchMessage();
    // 案件詳細取得, ページ状態管理
    const { loading, rfp } = useRfpOneProfessional({
        afterCallbackInApproved: fetchFileShare,
    });
    // ローディング表示
    if (loading && !rfp) {
        return (_jsx(RfpProfessionalOneSkeletonLayout, { skeletonComponent: _jsx(RfpProfessionalNegotiateSkeleton, {}) }));
    }
    // リダイレクト：案件が取得できなかった
    if (!loading && !rfp) {
        return _jsx(CustomRedirect, { to: myPagePath() });
    }
    // リダイレクト：閲覧申請未承認だった or ファイル未共有である
    if (rfp.data_type === RFP_PROFESSIONAL_DATA_TYPE_UNAPPROVED.value ||
        !rfp.has_share_document) {
        return _jsx(CustomRedirect, { to: rfpOnePath });
    }
    return (_jsx(RfpProfessionalFilePage, { changeFileShareData: changeFileShareData, fetchFileShare: fetchFileShare, fileShare: fileShareData, profile: profile, rfp: rfp }));
};
